import './css/styles.scss';

function ikonListaInit() {}

ikonListaInit();
